<template>
  <div>

    <div
      v-show="!edit"
      @mouseover="pencil = true"
      @mouseleave="pencil = false"
      class="header_column"
      v-on:dblclick="enableEditColumn"
    >
      <b class="color-grey-primary pointer">
        <font-awesome-icon
          class="dark_grey"
          @click="edit = true"
          v-show="pencil"
          icon="pencil-alt"
        />
      </b>
      <div
        class="nav menu_column nav-tabs right"
        style="border: 0px !important"
      >
        <li class="nav-item dropdown">
          <a
            class="nav-link"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <font-awesome-icon
              class="dark_grey"
              icon="ellipsis-v"
            />
          </a>
          <div class="dropdown-menu">
            <div
              v-if="selective_process.status != 1"
              @click="removeColumn"
              class="dropdown-item pointer"
            >
              DELETAR COLUNA
            </div>

            <div
              @click="editFeedback"
              class="dropdown-item pointer"
            >
              EDITAR FEEDBACK
            </div>

            <div
              @click="addData"
              class="dropdown-item pointer"
            >
              COLETAR DADOS
            </div>
          </div>
        </li>
      </div>
      <b
        v-show="selective_process.feedback"
        class="mr-1 total_in_column icon_kanban_blue"
      >
        <font-awesome-icon icon="video" />
      </b>

      <b
        v-show="selective_process.field_mapping_ids.length > 0"
        class="mr-1 total_in_column icon_kanban_blue"
      >
        <font-awesome-icon icon="database" />
      </b>
    </div>
    <div v-show="edit">
      <input
        ref="column_name"
        type="text"
        class="form-control"
        v-on:keyup.enter="changeName"
        v-model="column_name"
      />
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import EditFeedback from "@/Recruiters/LimitedKanban/EditFeedback.vue";
import FieldMappingIndex from "components/FieldMapping/Index.vue";
export default {
  components: {
    FieldMappingIndex,
  },
  props: [
    "selective_process",
    "total_in_column",
    "questions",
    "index",
    "gallery",
    "job_id",
    "recruiter_id",
  ],
  data: () => ({
    edit: false,
    column_name: "",
    pencil: false,
    gallery_current: {},
  }),
  mounted() {
    this.gallery_current = this.gallery;
  },
  methods: {
    addData() {
      this.$modal.show(
        FieldMappingIndex,
        {
          entity: "candidates",
          entity_data: {
            name: "selective_process_id",
            id: this.selective_process.id,
            field_data: this.selective_process,
          },
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    editFeedback() {
      this.gallery_current.item_category_id = 4; // CATEGORY_SELECTIVE_PROCESS

      this.$modal.show(
        EditFeedback,
        {
          selective_process: this.selective_process,
          gallery: this.gallery_current,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            eventBus.$emit("makeKanbanForm", true);
            eventBus.$emit("setDraggable", true);
          },
        }
      );
    },
    enableEditColumn() {
      this.edit = true;
      this.$refs.column_name.focus();
    },
    removeColumn() {
      if (this.total_in_column != 0) {
        this.$toast.error("Você não pode remover uma coluna com candidatos");
        return;
      }

      if (this.questions > 0) {
        this.$toast.error("Você não pode remover uma coluna com perguntas");
        return;
      }

      let conf = confirm("Tem certeza que deseja deletar essa coluna?");
      if (!conf) return;
      axios
        .delete(
          `/recruiters/jobs/${this.job_id}/kanban/delete_column/${this.selective_process.id}`
        )
        .then((response) => {
          if (response.data.status) {
            eventBus.$emit("remove_columnForm", true);
            this.$toast.success("Coluna Removida com sucesso");
            return;
          }
          this.$toast.error("Você não tem permissão para remover essa coluna");
          return;
        });
    },
    changeName() {
      this.$v.column_name.$touch();

      if (this.$v.column_name.$invalid) {
        this.$toast.error("Nome da coluna inválido");
        return;
      }
      axios
        .put(
          `/recruiters/jobs/${this.selective_process.job_id}/kanban/change_name_column`,
          {
            kanban: {
              column_name: this.column_name,
              selective_process_id: this.selective_process.id,
            },
          }
        )
        .then((response) => {
          this.edit = false;
          eventBus.$emit("changeNameForm", this.index);
        });
    },
  },
  validations: {
    column_name: { required, minLength: minLength(3) },
  },
};
</script>

<style>
</style>